<template>
    <div class="userBase">
        <div class="left-header">
            <div class="logo">
                <router-link to="/index">
                    <img src="../assets/img/user-interface-logo.png">
                    <p>Teach:able</p>
                </router-link>
            </div>
            <div class="username">
                <img @click="handleRoute('/profile')" src="../assets/img/student-profile-image.png">
                <p class="name">{{username}}</p>
                <p class="email">{{email}}</p>
            </div>
            <div class="menu">
                <div class="menu-item" @click="handleRoute('/profile')">
                    <p><i class="el-icon-user"></i>My Profile</p>
                </div>
                <div class="menu-item" @click="handleRoute('/myCourse')">
                    <p><i class="el-icon-date"></i>My Courses</p>
                </div>
                <div class="menu-item" @click="handleRoute('/billing')">
                    <p><i class="el-icon-bank-card"></i>Billings</p>
                </div>
            </div>
            <div class="logout">
                <p @click="logout()">Logout</p>
            </div>
        </div>
        <div class="mobile-header">
            <router-link to="/index">
                <img class="logo" src="../assets/img/mobile/menu-logo.png">
            </router-link>
                <img class="menu" @click="handleMenu" src="../assets/img/mobile/user-interface-menu-icon.png">
        </div>
        <div v-if="showMenu == true" class="mobile-menu">
            <img class="close" @click="showMenu = false" src="../assets/img/mobile/user-interface-menu-close-icon.png">
            <div class="profile">
                <img src="../assets/img/mobile/user-interface-menu-profile-pic.png">
                <div class="profile-item">
                    <div class="name">{{username}}</div>
                    <div class="email">{{email}}</div>
                </div>
            </div>
            <div class="menu">
                <div class="menu-item" @click="handleRoute('/profile')">
                    <p><img src="../assets/img/mobile/user-icon.png">My Profile</p>
                </div>
                <div class="menu-item" @click="handleRoute('/myCourse')">
                    <p><img src="../assets/img/mobile/courses-icon.png">My Courses</p>
                </div>
                <div class="menu-item" @click="handleRoute('/billing')">
                    <p><img src="../assets/img/mobile/billings-icon.png">Billings</p>
                </div>
            </div>
            <div class="logout" @click="logout()">Logout</div>
        </div>
        <div class="user-child-layout">
            <router-view/>
        </div>
        <div class="mobile-footer">
            <div class="copyright">
                © Online Learning Hub 2021
            </div>
            <div class="text">
                Terms of Use | Privacy Policy
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Profile Header",
        data() {
            return {
                showMenu: false,

                /* get user info */
                username: "",
                email: ""
            }
        },
        mounted () {
            this.init();
        },
        methods: {
            handleRoute(link) {
                this.$router.push({path: '/user' + link});
                this.showMenu = false;
            },
            handleMenu(){
                this.showMenu = true;
            },

            /* get user info */
            init() {
                this.$api.request('User/info').then((result) => {
                    if (result.status == true) {
                        let results = result.data;
                        this.username = results.name;
                        this.email = results.email;
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            },

            /* logout */
            logout() {
                this.$api.request('User/logout').then((result) => {
                    if (result.status == true) {
                        localStorage.removeItem('token');
                        this.$message.warning('Logout successfully');

                        setTimeout(function() {
                            window.location = '/index';
                        }, 2000);
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            }
        },
    }
</script>

<style lang='scss' type='text/css'>
    @import "../styles/pc/ProfileHeader.scss";
    @import "../styles/mobile/ProfileHeader.scss";
</style>
